var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDeleteMain24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_brand_deactivate24x24",
    d: "M10,2a7.922,7.922,0,0,0-8,8,7.922,7.922,0,0,0,8,8,7.922,7.922,0,0,0,8-8A7.922,7.922,0,0,0,10,2Zm3.44,10.24-1.28,1.28A27.492,27.492,0,0,0,10,11.36a27.492,27.492,0,0,0-2.16,2.16L6.56,12.24a27.492,27.492,0,0,0,2.16-2.16A30.119,30.119,0,0,0,6.4,7.84L7.68,6.56S9.76,8.72,9.84,8.72,12,6.56,12,6.56l1.28,1.28A27.492,27.492,0,0,0,11.12,10c.24.16,2.32,2.24,2.32,2.24Z",
    transform: "translate(-2 -2)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDeleteMain24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_delete_main24x24.9f39442740c26d96d3152de06958e18c.svg";